const playCards = document.querySelector('.play-cards')

document.addEventListener('DOMContentLoaded', () => {

  if(playCards) {

    const iteraItems = () => {

      const playCardsContent = playCards.querySelectorAll('.play-cards--content .play-cards--item')

      playCardsContent.forEach(cardItem => {
        
        cardItem.addEventListener('click', (e) => {

          playCardsContent.forEach(otherCard => {
            const gift = otherCard.querySelector('.play-cards--gift')
            otherCard.classList.remove('active')
            otherCard.classList.add('disable')
            gift.classList.remove('card--hidden')
          });
  
          cardItem.classList.add('active')
          cardItem.classList.remove('disable')

          if (e.target.classList.contains('active')) {

            const query = async () => {

              try {
                const urlQuery = '/prize/win'
                const reqQuery = await fetch(urlQuery)
                const resQuery = await reqQuery.json()

                if (reqQuery.status == 200) {

                  const imgGift = document.querySelector('.play-cards--item.active .play-cards--gift')
                  const titlePlay = document.querySelector('#play-cards__title h1')
                  const cardsContainer = document.querySelector('.play-cards--content')
                  const imgPrize = document.querySelector('.play-cards--img')
                  const btnContinue = document.querySelector('.play-cards--continue')
                  const subTitle = document.querySelector('.play-cards--header__subtitle')

                  if (imgPrize || btnContinue || subTitle) {
                    imgPrize.remove()
                    btnContinue.remove()
                    subTitle.remove()
                  }

                  setTimeout(() => {  

                    if (resQuery.status == 'haveprize' || resQuery.status == 'yesprize') {

                      const imgWin = document.createElement('img')
                      imgWin.classList.add('play-cards--img')
                      imgWin.src = `${resQuery.image.uri ? resQuery.image.uri : ''}`
                      imgWin.alt = `${resQuery.image.alt ? resQuery.image.alt : ''}`
                      imgGift.insertAdjacentElement('afterend', imgWin)
                      imgGift.classList.add('card--hidden')
                      const spanWinner = document.createElement('span')
                      spanWinner.classList.add('play-cards--header__subtitle')
                      spanWinner.innerHTML = resQuery.title ? resQuery.title : ''
                      titlePlay.insertAdjacentElement('beforebegin', spanWinner)

                      if (resQuery.status == 'haveprize') {
                        spanWinner.remove()
                        titlePlay.innerHTML = resQuery.paragraph ? resQuery.paragraph : ''
                      }

                      if (resQuery.status == 'yesprize') {
                        titlePlay.innerHTML = resQuery.node_title ? resQuery.node_title: ''
                      }

                      let btnW = resQuery.text_butom ? resQuery.text_butom : 'CLICK TO CONTINUE'
                      let urlW = resQuery.url_button ? resQuery.url_button : '/'

                      cardsContainer.insertAdjacentHTML('beforeend', `<div class="play-cards--continue"><a href="${urlW}">${btnW}</a></div>`)

                    }

                    if (resQuery.status == 'tryagain' || resQuery.status == 'noprize') {

                      const textTry = document.createElement('div')
                      textTry.classList.add('play-cards--try')
                      textTry.innerHTML = resQuery.body ? resQuery.body : '<p>Try Again</p>';
                      imgGift.insertAdjacentElement('afterend', textTry)
                      imgGift.classList.add('card--hidden')

                      titlePlay.innerHTML = resQuery.title ? resQuery.title : ''

                      playCardsContent.forEach(cardItemDisale => {

                        if (cardItemDisale.classList.contains('disable')) {
                          const referenceImg = cardItemDisale.querySelector('.play-cards--gift')
                          if (resQuery.other_prize.length > 0) {

                            const otherImage = document.createElement('img')
                            otherImage.classList.add('play-cards--imgOther')

                            let imageRandom = Math.floor(Math.random() * resQuery.other_prize.length)
                            let urlImageRandom = resQuery.other_prize[imageRandom]

                            otherImage.src = `${urlImageRandom.image.uri ? urlImageRandom.image.uri : ''}`
                            referenceImg.insertAdjacentElement('afterend', otherImage)
                            referenceImg.classList.add('card--hidden')

                          }
                        }

                      });

                      let btnL = resQuery.text_butom ? resQuery.text_butom : 'VIEW MORE'
                      let urlL = resQuery.url_button ? resQuery.url_button : '/'

                      cardsContainer.insertAdjacentHTML('beforeend', `<div class="play-cards--continue"><a href="${urlL}">${btnL}</a></div>`)

                    }

                    if (resQuery.status == 'experience') {

                      if (resQuery.body !== null) {
                        const textExp = document.createElement('div')
                        textExp.classList.add('play-cards--experience')
                        textExp.innerHTML = resQuery.body ? resQuery.body : '';
                        imgGift.insertAdjacentElement('afterend', textExp)
                      } else if (resQuery.image.uri !== undefined) {
                        const imageExp = document.createElement('img')
                        imageExp.classList.add('play-cards--imgExp')
                        imageExp.src = `${resQuery.image.uri}`
                        imgGift.insertAdjacentElement('afterend', imageExp)
                      }
                      
                      imgGift.classList.add('card--hidden')

                      titlePlay.innerHTML = resQuery.node_title ? 'Experience: ' + resQuery.node_title : ''

                      const spanExp = document.createElement('span')
                      spanExp.classList.add('play-cards--header__subtitle')
                      spanExp.innerHTML = resQuery.title ? resQuery.title : ''
                      titlePlay.insertAdjacentElement('beforebegin', spanExp)

                      let btnE = resQuery.text_butom ? resQuery.text_butom : 'CLICK TO CONTINUE'
                      let urlE = resQuery.url_button ? resQuery.url_button : '/'

                      cardsContainer.insertAdjacentHTML('beforeend', `<div class="play-cards--continue"><a href="${urlE}">${btnE}</a></div>`)

                    }

                  }, 1600);

                } else if (reqQuery.status == 403) {

                  let pathOrigin = window.location.origin;
                  window.location.href = `${pathOrigin}/otp/login`

                } else if (reqQuery.status == 500) {
                  const cardsContainer = document.querySelector('.play-cards--content')
                  cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--error"><p>500 INTERNAL SERVER ERROR</p></div>')
                }

              } catch (error) {
                const cardsContainer = document.querySelector('.play-cards--content')
                cardsContainer.insertAdjacentHTML('beforeend', '<div class="play-cards--error"><p>YOU ARE TRYING AN INVALID ACTION. CLICK <a href="/otp/login">HERE</a></p></div>')
              }

            }

            query()
            
          }

        })

      });

    }

    iteraItems()

  }

})



// WEBPACK FOOTER //
// ./js/components/otp/_otp--cards.js